import { CustomFieldsService, CustomFieldsProvider, HttpService } from '@lk/api'

export const makeCustomFieldsService = (http: HttpService, baseUrl: string) =>
  new CustomFieldsService(new CustomFieldsProvider(http, baseUrl))
